<table class="table-calendar month-mode" (window:resize)="windowResized()">
	<thead>
		<tr>
			<td
				[ngClass]="{
					activeDayOfWeek: currentMonthVisible && activeDayOfWeek == 0
				}"
			>
				<span *ngIf="!isMobile">{{
					'CALENDAR.WEEKDAYS.SUN.SHORT' | translate | uppercase
				}}</span>
				<span *ngIf="isMobile">{{
					'CALENDAR.WEEKDAYS.SUN.FIRST' | translate | uppercase
				}}</span>
			</td>
			<td
				[ngClass]="{
					activeDayOfWeek: currentMonthVisible && activeDayOfWeek == 1
				}"
			>
				<span *ngIf="!isMobile">{{
					'CALENDAR.WEEKDAYS.MON.SHORT' | translate | uppercase
				}}</span>
				<span *ngIf="isMobile">{{
					'CALENDAR.WEEKDAYS.MON.FIRST' | translate | uppercase
				}}</span>
			</td>
			<td
				[ngClass]="{
					activeDayOfWeek: currentMonthVisible && activeDayOfWeek == 2
				}"
			>
				<span *ngIf="!isMobile">{{
					'CALENDAR.WEEKDAYS.TUE.SHORT' | translate | uppercase
				}}</span>
				<span *ngIf="isMobile">{{
					'CALENDAR.WEEKDAYS.TUE.FIRST' | translate | uppercase
				}}</span>
			</td>
			<td
				[ngClass]="{
					activeDayOfWeek: currentMonthVisible && activeDayOfWeek == 3
				}"
			>
				<span *ngIf="!isMobile">{{
					'CALENDAR.WEEKDAYS.WED.SHORT' | translate | uppercase
				}}</span>
				<span *ngIf="isMobile">{{
					'CALENDAR.WEEKDAYS.WED.FIRST' | translate | uppercase
				}}</span>
			</td>
			<td
				[ngClass]="{
					activeDayOfWeek: currentMonthVisible && activeDayOfWeek == 4
				}"
			>
				<span *ngIf="!isMobile">{{
					'CALENDAR.WEEKDAYS.THU.SHORT' | translate | uppercase
				}}</span>
				<span *ngIf="isMobile">{{
					'CALENDAR.WEEKDAYS.THU.FIRST' | translate | uppercase
				}}</span>
			</td>
			<td
				[ngClass]="{
					activeDayOfWeek: currentMonthVisible && activeDayOfWeek == 5
				}"
			>
				<span *ngIf="!isMobile">{{
					'CALENDAR.WEEKDAYS.FRI.SHORT' | translate | uppercase
				}}</span>
				<span *ngIf="isMobile">{{
					'CALENDAR.WEEKDAYS.FRI.FIRST' | translate | uppercase
				}}</span>
			</td>
			<td
				[ngClass]="{
					activeDayOfWeek: currentMonthVisible && activeDayOfWeek == 6
				}"
			>
				<span *ngIf="!isMobile">{{
					'CALENDAR.WEEKDAYS.SAT.SHORT' | translate | uppercase
				}}</span>
				<span *ngIf="isMobile">{{
					'CALENDAR.WEEKDAYS.SAT.FIRST' | translate | uppercase
				}}</span>
			</td>
		</tr>
	</thead>

	<tbody [@tableAnimation]>
		<tr>
			<td colspan="7" style="padding: 0">
				<div
					*ngIf="isLoading"
					style="margin-top: 60px; padding: 50px 20px; text-align: center"
				>
					<freud-loader size="sm" [bgColor]="false"></freud-loader>
				</div>
				<div
					*ngIf="!isLoading"
					id="calendar-scroll-container"
					class="scroll-container"
				>
					<table class="table-calendar month-mode" style="border: none">
						<tbody>
							<tr *ngFor="let weeks of arDays">
								<td
									(click)="showEventsOfDay(day.day, day.month)"
									*ngFor="let day of weeks"
									[attr.today]="day.today"
									[ngClass]="{
										'of-day': day.offDay,
										'on-day': !day.offDay,
										'past-day': day.pastDay
									}"
								>
									<div
										class="day-number"
										[attr.data-year]="activeYear"
										[attr.data-month]="day.month"
										[attr.data-day]="day.day"
									>
										{{ day.day }}
									</div>

									<div class="day-content">
										<fa-icon #faIcon icon="circle" hidden></fa-icon>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</td>
		</tr>
	</tbody>
</table>
